var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { C as CustomEvents } from "./events-DeC3n8dp.js";
import { m as morph } from "./morph-BX9Iqu9G.js";
import "./component-cLJ9vlHA.js";
import "./critical-Da0Dmhh9.js";
import "./utilities-2Suih3Nm.js";
class ProductCountdownTimerV2 extends HTMLElement {
  constructor() {
    super();
    __publicField(this, "handleVariantPickerUpdate", (event) => {
      if (event.detail.data.productId !== this.dataset.productId) return;
      const newCountdownTimer = event.detail.data.html.querySelector("product-countdown-timer-v2");
      if (newCountdownTimer) morph(this, newCountdownTimer);
    });
  }
  connectedCallback() {
    const section = this.closest(".shopify-section");
    if (!section) return;
    section.addEventListener(CustomEvents.variantPickerUpdate, this.handleVariantPickerUpdate);
  }
}
if (!customElements.get("product-countdown-timer-v2")) {
  customElements.define("product-countdown-timer-v2", ProductCountdownTimerV2);
}
